import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/XMP/XMP Classes/XMPPacketInfo.md";
import * as React from 'react';
export default {
  Content,
  React
};